import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="survey-template-picker"
//
// Toggles the inline "Create from template" panel inside the survey step drawer
// open and closed, so the admin can pick a published template without leaving
// the drawer.
//
// DOM contract:
//   trigger button -> target "trigger" with data-action="survey-template-picker#toggle"
//   panel          -> target "panel" (starts with the `hidden` class)
export default class extends Controller {
  static targets = ["panel"];

  toggle() {
    if (!this.hasPanelTarget) return;

    this.panelTarget.classList.toggle("hidden");
  }
}
